module.exports = __webpack_public_path__ + "img/icon_dgmn.48084c9d.png";